import { render } from "./detailsCardView.vue?vue&type=template&id=215b037f&scoped=true"
import script from "./detailsCardView.vue?vue&type=script&lang=js"
export * from "./detailsCardView.vue?vue&type=script&lang=js"

import "./detailsCardView.vue?vue&type=style&index=0&id=215b037f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-215b037f"]])

export default __exports__